import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { BadgeDollarSign, Building2, CalendarDays, FileText, KeyRound, ListChecks, MapPin, MessageSquareText, ShieldOff, Tags, Users, Waypoints, Workflow, Zap } from "lucide-react";
import { useMe } from "@web/lib/session";
import { EmptyState, Page, Row, RowGroup } from "@web/ui";
import { CheckAllSheet } from "./sheets/CheckAllSheet";

/** Reused by every admin-only screen. */
export function AdminsOnly() {
  return (
    <Page>
      <EmptyState icon={ShieldOff} title="Company admins only" body="Ask a company admin if you need something changed here." />
    </Page>
  );
}

export function Settings() {
  const me = useMe();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(false);
  if (!me.companyAdmin) return <AdminsOnly />;
  return (
    <Page>
      <RowGroup>
        <Row icon={<ListChecks aria-hidden size={22} />} title="Check all records" subtitle="Shared validation, missing details and record relationships" onClick={() => setChecking(true)} />
        <Row icon={<Building2 aria-hidden size={22} />} title="Company" subtitle="Name, contact, deposit and fee defaults" onClick={() => navigate({ to: "/settings/company" })} />
        <Row icon={<MapPin aria-hidden size={22} />} title="Venues" subtitle="Colors, capacity, damage deposit" onClick={() => navigate({ to: "/settings/venues" })} />
        <Row icon={<Tags aria-hidden size={22} />} title="Catalog" subtitle="Packages, fees, add-ons, day rates" onClick={() => navigate({ to: "/settings/catalog" })} />
        <Row icon={<ListChecks aria-hidden size={22} />} title="Event types" onClick={() => navigate({ to: "/settings/event-types" })} />
        <Row icon={<Waypoints aria-hidden size={22} />} title="Lead sources" onClick={() => navigate({ to: "/settings/lead-sources" })} />
        <Row icon={<FileText aria-hidden size={22} />} title="Contract templates" subtitle="Versioned, read-only agreement previews" onClick={() => navigate({ to: "/settings/contract-templates" })} />
        <Row icon={<MessageSquareText aria-hidden size={22} />} title="Message templates" subtitle="The words every automated message uses" onClick={() => navigate({ to: "/settings/message-templates" })} />
        <Row icon={<Workflow aria-hidden size={22} />} title="Drip sequences" subtitle="Long sales sequences, on or off" onClick={() => navigate({ to: "/settings/drip-sequences" })} />
        <Row icon={<Tags aria-hidden size={22} />} title="Vendor categories" subtitle="What your vendors are filed under" onClick={() => navigate({ to: "/settings/vendor-categories" })} />
        <Row icon={<BadgeDollarSign aria-hidden size={22} />} title="Payments" subtitle="Commission rules and what clients can pay with" onClick={() => navigate({ to: "/settings/payments" })} />
        <Row icon={<Zap aria-hidden size={22} />} title="Automation" subtitle="Auto-send switch, quiet hours, reminder days" onClick={() => navigate({ to: "/settings/automation" })} />
        <Row icon={<CalendarDays aria-hidden size={22} />} title="Calendar" subtitle="The shared Google calendar staff see" onClick={() => navigate({ to: "/settings/calendar" })} />
        <Row icon={<Users aria-hidden size={22} />} title="Users" subtitle="Invite, roles, active, venues" onClick={() => navigate({ to: "/settings/users" })} />
        <Row icon={<KeyRound aria-hidden size={22} />} title="API keys" subtitle="Website lead intake" onClick={() => navigate({ to: "/settings/api-keys" })} />
      </RowGroup>
      {checking && <CheckAllSheet onClose={() => setChecking(false)} />}
    </Page>
  );
}
